import { i18n } from '@/plugins/i18n'


export default [
    {
        field: 'id',
        title: i18n.t('online-factor.hash_id'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'payment_amount',
        title: i18n.t('online-factor.amount'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'wage',
        title: i18n.t('online-factor.wage'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'discount_amount',
        title: i18n.t('online-factor.discount_amount'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'payment_status',
        title: i18n.t('online-factor.status'),
        sortable: false,
        template: (row) => {
            if (row.payment_status == 0) {
                return '<span class="badge badge-secondary font-weight-bold px-2 py-1" dir="ltr">در انتظار</span>'
            }

            if (row.payment_status == 1) {
                return '<span class="badge badge-danger font-weight-bold px-2 py-1" dir="ltr">لغو شده</span>'
            }

            if (row.payment_status == 2) {
                return '<span class="badge badge-success font-weight-bold px-2 py-1" dir="ltr">موفق</span>'
            }
        },
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('online-factor.created_at'),
        sortable: false,
        textAlign: 'center',
        width: 80,
    },
    {
        field: 'paid_at',
        title: i18n.t('online-factor.paid_at'),
        sortable: true,
        textAlign: 'center',
        width: 80,
    },
]
